import React,{useEffect, useState} from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from "js-cookie";
import BaseUrl from '../Components/BaseUrl';


const Onboardingstep4 = () => {
    
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
      title: "",
      employment_type:"",
      company:"",
      
    });
    const [error, setError] = useState({
        title: "",
        employment_type:"",
        company:"",
    })

    const handleChange = (e) => {
        const {id,value}=e.target;
        setFormData({...formData,[id]:value})
        setError({...error,[id]:""})
    }
    const validateForm = () => {
        let isValid = true;
        let errors = {};
        if (formData.title.trim() === "") {
            errors.title = "Job Title is required";
            isValid = false;
        }
        if (formData.employment_type.trim() === "") {
            errors.employment_type = "Employment Type is required";
            isValid = false;
        }
        if (formData.company.trim() === "") {
            errors.company = "Company is required";
            isValid = false;
        }
        setError(errors);  
        return isValid;  
    };
    
    const handleSubmit=async(e)=>{
        e.preventDefault();
        const user_id = Cookies.get("user_id");
        const result=validateForm();
        if(result){
          console.log(result)
            try {
                const response = await axios.post(
                  BaseUrl + "onboarding/step4",
                  formData,
                  {
                    headers: {
                      "user-id": user_id,
                    },
                  }
                );
                console.log(response.data.status);
                if(response.status===200){
                      setFormData({
                        title: "",
                        employment_type:"",
                        comapany:"",
                      });
                    setTimeout(() => {
                        navigate("/user/onboarding/step5")
                    }, 100);
            }
            
        }
        catch (error) {
            console.log(error)
        }
    }
    }
    
  return (
    <>
      <div className="flex flex-col items-center mt-12 justify-start min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
        <div className="w-2/4 mb-4 mt-6 ">
          <p className="text-3xl  mb-2 text-center">
            {" "}
            Your profile helps you discover new people and opportunities
          </p>
        </div>
        <div className="w-full max-w-md">
          <form className="bg-white p-8 rounded-lg shadow-xl ">
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="name"
              >
                Most recent job title <span className="text-red-500">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="title"
                value={formData.title}
                onChange={handleChange}
                type="text"
                placeholder="Job Title "
              />
              <span className="text-red-500 ml-1 text-sm mb-1">
                {error.title}
              </span>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-1">
                Employment type <span className="text-red-500">*</span>
              </label>
              <select
                className="mt-1 block w-full border-b-2 border-black rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-600 focus:border-blue-600 sm:text-sm"
                id="employment_type"
                value={formData.employment_type}
                onChange={handleChange}
              >
                <option value="">Please Select</option>
                <option value="Full-time">Full-time</option>
                <option value="Part-time">Part-time</option>
                <option value="Self-employed">Self-employed</option>
                <option value="Freelance">Freelance</option>
                <option value="Internship">Internship</option>
                <option value="Trainee">Trainee</option>
              </select>
              <span className="text-red-500 ml-1 text-sm mb-1">
                {error.employment_type}
              </span>
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="name"
              >
                Most recent company <span className="text-red-500">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="company"
                value={formData.company}
                onChange={handleChange}
                type="text"
                placeholder="Most recent company "
              />
              <span className="text-red-500 ml-1 text-sm mb-1">
                {error.company}
              </span>
            </div>


            <div className=" mt-2 flex flex-col items-center justify-center w-full">
              <Link to={"/user/onboarding/student"}
                className=" hover:text-black text-center text-gray-600 text-lg font-bold py-2 px-4 h-12 rounded-full w-full "
              >
                I'm a student
              </Link>
            </div>

            <div className=" mt-2 flex flex-col items-center">
              <button
                className="bg-[#0A66C2] hover:bg-blue-700 text-white text-lg font-bold py-2 px-4 h-12 rounded-full w-full"
                type="button"
                onClick={handleSubmit}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Onboardingstep4;
